module.exports = __webpack_public_path__ + "static/media/HomeTab5.6ce4310d.jpg";